import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PagesGuard } from '@core/guards/pages.guard';
import { dashboardRoutes } from './routesDashboard';
import { devtoolsRoutes } from './routesDevtools';
import { publicRoutes } from './routesPublic';
import { authRoutes } from './routesAuth';

const routes: Routes = [
  {
    path: 'dashboard',
    loadComponent: () => import('@shared/components/layouts/layout-dashboard/layout-dashboard.component').then(mod => mod.LayoutDashboardComponent),
    canActivate: [PagesGuard],
    children: dashboardRoutes
  },
  {
    path: 'devtools',
    loadComponent: () => import('@shared/components/layouts/layout-devtools/layout-devtools.component').then(mod => mod.LayoutDevtoolsComponent),
    children: devtoolsRoutes
  },
  {
    path: '',
    loadComponent: () => import('@shared/components/layouts/layout-auth/auth-layout.component').then(mod => mod.LayoutAuthComponent),
    children: authRoutes
  },
  {
    path: '',
    children: publicRoutes
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class PagesRoutingModule { }
